import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import { Autoplay, EffectFade, Navigation } from 'swiper/modules';

export function cardSlider(element, customOptions = {}) {
  const defaultOptions = {
    modules: [Navigation, EffectFade, Autoplay],
    slidesPerView: 1.25,
    speed: 600,
    mousewheel: true,
    grabCursor: true,
    breakpoints: {
      480: {
        slidesPerView: 1.8,
      },
      768: {
        slidesPerView: 2.5,
      },
      992: {
        slidesPerView: 3.5,
      },
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
  };

  const options = {
    ...defaultOptions,
    ...customOptions,
    breakpoints: {
      ...defaultOptions.breakpoints,
      ...customOptions.breakpoints,
    },
  };

  const swiperSliderGroups = document.querySelectorAll(element);

  swiperSliderGroups.forEach((swiperGroup) => {
    const swiperSliderWrap = swiperGroup.querySelector('[data-swiper-wrap]');
    if (!swiperSliderWrap) return;

    const prevButton = swiperGroup.querySelector('[data-swiper-prev]');
    const nextButton = swiperGroup.querySelector('[data-swiper-next]');

    new Swiper(swiperSliderWrap, {
      ...options,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
    });
  });
}
